export const actions = {
  CP_INTERNACIONALES_LOAD_REQUESTED: 'CP_INTERNACIONALES_LOAD_REQUESTED',
  CP_INTERNACIONALES_LOAD_SUCCEEDED: 'CP_INTERNACIONALES_LOAD_SUCCEEDED',
  CP_INTERNACIONALES_LOAD_FILED: 'CP_INTERNACIONALES_LOAD_FILED',

  CP_INTERNACIONAL_UPDATE_REQUESTED: 'CP_INTERNACIONAL_UPDATE_REQUESTED',
  CP_INTERNACIONAL_UPDATE_SUCCEEDED: 'CP_INTERNACIONAL_UPDATE_SUCCEEDED',
  CP_INTERNACIONAL_UPDATE_FILED: 'CP_INTERNACIONAL_UPDATE_FILED',

  CP_INTERNACIONAL_INSERT_REQUESTED: 'CP_INTERNACIONAL_INSERT_REQUESTED',
  CP_INTERNACIONAL_INSERT_SUCCEEDED: 'CP_INTERNACIONAL_INSERT_SUCCEEDED',
  CP_INTERNACIONAL_INSERT_FILED: 'CP_INTERNACIONAL_INSERT_FILED',

  CP_INTERNACIONAL_DELETE_REQUESTED: 'CP_INTERNACIONAL_DELETE_REQUESTED',
  CP_INTERNACIONAL_DELETE_SUCCEEDED: 'CP_INTERNACIONAL_DELETE_SUCCEEDED',
  CP_INTERNACIONAL_DELETE_FILED: 'CP_INTERNACIONAL_DELETE_FILED',
}

export const getCPInternacionalesAction = (dispatch, paisId) => {
  dispatch({
    type: actions.CP_INTERNACIONALES_LOAD_REQUESTED,
    payload: paisId,
  })
}

export const onSubmitInsertCPInternacionalFormAction = (dispatch, formCPInternacional) => {
  dispatch({
    type: actions.CP_INTERNACIONAL_INSERT_REQUESTED,
    payload: formCPInternacional,
  })
}

export const onSubmitUpdateCPInternacionalFormAction = (dispatch, formCPInternacional) => {
  dispatch({
    type: actions.CP_INTERNACIONAL_UPDATE_REQUESTED,
    payload: formCPInternacional,
  })
}

export const deleteCPInternacionalAction = (dispatch, id) => {
  dispatch({
    type: actions.CP_INTERNACIONAL_DELETE_REQUESTED,
    payload: id,
  })
}
